// extracted by mini-css-extract-plugin
export default {"topSection":"PageHeading_topSection__+pxqV","description":"PageHeading_description__-0sso"};